import { useContext } from 'react';

import { Tab, Tabs } from '@mui/material';

import { PartnershipManagement } from '@company/components/layout/CompanyManagement/PartnershipManagement';
import { UserManagement } from '@company/components/layout/CompanyManagement/UserManagement';
import { CompanyManagementContext } from '@company/contexts/CompanyManagementContext';
import { usePrefixedNavigate } from '@hooks/usePrefixedNavigate';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSearchParams } from 'react-router-dom';

const TAB_CLASSNAME = 'font-inter font-bold text-sm';

enum TABS {
    USER_MANAGEMENT = 0,
    PARTNERSHIP_MANAGEMENT = 1,
    EDIT = 2,
}

/**
 * This component is to be used in both public and dashboard.
 *
 * Only in public you'll have the leave company action.
 *
 * Only in dashboard, and with victron role, you'll be able to remove users from a company. (Sales managers have access to the dashboard but can't remove users from a company).
 */
const CompanyManagement = () => {
    const { permissions } = useContext(CompanyManagementContext);
    const [searchParams] = useSearchParams();
    const tab = Number(searchParams.get('tab'));
    const navigate = usePrefixedNavigate();

    const getCurrentTab = (tab: number) => {
        if (isNaN(tab) || tab > TABS.EDIT) {
            return TABS.USER_MANAGEMENT;
        }
        if (
            (tab === TABS.EDIT && !permissions?.edit) ||
            (tab === TABS.PARTNERSHIP_MANAGEMENT && !permissions?.partnerships.view)
        ) {
            return TABS.USER_MANAGEMENT;
        }
        return tab;
    };
    const currentTab = getCurrentTab(tab);

    return (
        <div className="flex flex-col">
            <Tabs
                value={currentTab}
                onChange={(_, newValue) =>
                    navigate(
                        `${location.pathname}?tab=${newValue}${
                            searchParams.get('id') ? `&id=${searchParams.get('id')}` : ''
                        }`
                    )
                }
            >
                <Tab label={<p className={TAB_CLASSNAME}>User management</p>} />
                {permissions?.partnerships.view ? <Tab label={<p className={TAB_CLASSNAME}>Partnership</p>} /> : null}
                {permissions?.edit ? <Tab className="!ml-auto" icon={<SettingsIcon />} /> : null}
            </Tabs>
            <div className="flex flex-col min-h-[600px] w-full sm:p-5 p-0 gap-5 bg-white">
                {currentTab === 0 ? (
                    <UserManagement />
                ) : currentTab === 1 ? (
                    <PartnershipManagement />
                ) : (
                    <p>Next Ticket</p>
                )}
            </div>
        </div>
    );
};

export { CompanyManagement };
